import React, { useEffect, useState } from "react";
import { MapPin, Search, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import ListingCard from "./ListingCard";
import { get } from "../../utils/request";
import "./things-to-do.scss";

const ThingsToDoHome = () => {
  const navigate = useNavigate();
  const [countryFilter, setCountryFilter] = useState("All");
  const [keyword, setKeyword] = useState("");
  const [countries, setCountries] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [loadingRecommendations, setLoadingRecommendations] = useState(true);

  useEffect(() => {
    fetchCountries();
    fetchRecommendations();
  }, []);

  const fetchCountries = async () => {
    try {
      const result = await get("/thingsToDo/countries");
      setCountries(Array.isArray(result) ? result : []);
    } catch (error) {
      console.error("Failed to fetch Things To Do countries:", error);
      setCountries([]);
    }
  };

  const fetchRecommendations = async () => {
    setLoadingRecommendations(true);
    try {
      const result = await get("/thingsToDo/recommendations", { limit: 9 });
      setRecommendations(Array.isArray(result?.products) ? result.products : []);
    } catch (error) {
      console.error("Failed to fetch Things To Do recommendations:", error);
      setRecommendations([]);
    } finally {
      setLoadingRecommendations(false);
    }
  };

  const saveSearch = (event) => {
    event.preventDefault();
    const params = new URLSearchParams();
    params.set("query", keyword.trim());
    if (countryFilter !== "All") params.set("country", countryFilter);
    navigate(`/things-to-do/search?${params.toString()}`);
  };

  return (
    <>
      <Navbar />
      <main className="things-page pb-4">
        <section className="things-hero-section">
          <div className="things-hero-overlay" />
          <div className="container things-hero-content">
            <h1 className="things-hero-title">Unforgettable Journeys,</h1>
            <h2 className="things-hero-subtitle">Perfectly Bundled.</h2>
            <p className="things-hero-text">
              Discover attractions and experiences managed in Teleport Now&apos;s live catalogue.
            </p>

            <form className="things-hero-searchbar" onSubmit={saveSearch}>
              <div className="things-hero-field things-hero-field-full">
                <label htmlFor="things-home-query">Search experiences</label>
                <Search className="things-search-icon" aria-hidden="true" />
                <input
                  id="things-home-query"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="Attraction, activity or destination"
                />
              </div>
              <div className="things-hero-field things-hero-select">
                <label htmlFor="things-home-country">Destination</label>
                <MapPin className="things-search-icon" aria-hidden="true" />
                <select
                  id="things-home-country"
                  value={countryFilter}
                  onChange={(event) => setCountryFilter(event.target.value)}
                >
                  <option value="All">Anywhere</option>
                  {countries.map((country) => (
                    <option key={country} value={country}>{country}</option>
                  ))}
                </select>
              </div>
              <button type="submit" className="things-hero-search-btn">
                <Search aria-hidden="true" /> <span>Search</span>
              </button>
            </form>
          </div>
        </section>

        <div className="container things-discovery-content">
          <section className="mb-4">
            <div className="things-section-heading">
              <div>
                <p><Sparkles aria-hidden="true" /> Popular now</p>
                <h2 className="things-section-title">Most viewed Things To Do</h2>
              </div>
              <span>Based on verified listing views from the last 15 days.</span>
            </div>
            {loadingRecommendations && (
              <div className="things-results-status">Loading popular experiences…</div>
            )}
            {!loadingRecommendations && recommendations.length === 0 && (
              <div className="things-results-status">
                <p>Recommendations are temporarily unavailable.</p>
                <button type="button" onClick={fetchRecommendations}>Try again</button>
              </div>
            )}
            <div className="row g-3">
              {recommendations.map((listing) => (
                <div className="col-md-6 col-lg-4" key={listing.id}>
                  <ListingCard listing={listing} />
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ThingsToDoHome;
